import { createContext } from 'react';
import { makeObservable, observable, action } from 'mobx';

export class AgeAssessmentModalState {
    ageAssessment = null;

    constructor() {
        makeObservable(this, {
            ageAssessment: observable,
            show: action,
            close: action,
        });
    }
    show(ageAssessment) {
        this.ageAssessment = ageAssessment;
    }
    close() {
        this.ageAssessment = null;
    }
}
